import React, { useCallback, useState } from 'react'
import { FieldError } from 'react-hook-form'

import { Box, FormHelperText, IconButton, InputAdornment, OutlinedInput } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'

type Props = {
  id: string
  label: string
  error: FieldError
}

function InputTextField({ id, label, error, ...props }: Props, ref: React.Ref<HTMLInputElement>) {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = useCallback(() => {
    setShowPassword(!showPassword)
  }, [showPassword])

  return (
    <>
      <FormHelperText>{label}</FormHelperText>
      <OutlinedInput
        fullWidth
        ref={ref}
        id={id}
        type={showPassword ? 'text' : 'password'}
        color="success"
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={handleClickShowPassword} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        {...props}
        error={!!error}
      />
      <Box height={20}>
        <FormHelperText error>{error?.message}</FormHelperText>
      </Box>
    </>
  )
}

export default React.forwardRef(InputTextField)
